import React from 'react';

var MobilePlayForRealButtonHolder = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-play-for-real-m-btn-holder' }, children);
};

export { MobilePlayForRealButtonHolder };
